module.exports = "/_next/static/files/911c4c49c40bbdec937bf840246b31d2.jpg";